module.exports = __webpack_public_path__ + "img/kankou_2.43488de7.jpg";